import { useState, useEffect, useCallback } from "react";
import Grid from "../components/grid";
import Container from "../components/basicComponents/container";
import { removeArticle } from "../state-management/actions/article-actions";
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import ArticleComponent from "../components/article";
import { ArticleDataProps } from "../types/public";
import {
  editArticle,
  getArticles,
  getArticleById,
} from "../state-management/actions/article-actions";
import { setRowStatus } from "../state-management/actions/global-state-actions";
import { createNotificationData } from "../utils/createNotificationData";
import { addNotification } from "../state-management/actions/notification-actions";

const initialData = {
  title: "",
  department_id: "",
  content: "",
  description: "",
  author: "",
  index_picture: "",
  tags: "",
  is_active: false,
};

export default function ArticleList() {
  const dispatch = useDispatch();
  const { departmentsData, currentUserData, groupingData } =
    useSelector(selectGlobalState);
  const [articlesData, setArticlesData] = useState<any>([]);
  const [editFlag, setEditFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<any>({
    ...initialData,
    created_by: currentUserData._id,
  });
  const permissionDepartment = groupingData.find(
    (item: any) => item.user_id === currentUserData._id
  )?.department_id || ["none"];

  const fetchData = useCallback(async () => {
    try {
      const response = await getArticles()(dispatch);
      const filterData = response.data
        .filter((item: any) =>
          permissionDepartment.includes(item?.department_id)
        )
        .sort((a: any, b: any) => {
          const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
          const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
          return dateB - dateA;
        });
      setArticlesData(filterData);
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(setRowStatus("clear id", false));
    fetchData();
  }, []);

  const columns: any = [
    { headerName: "عنوان مقاله", field: "title", pinned: "right" },
    { headerName: "نویسنده", field: "author" },
    {
      headerName: "دسته بندی",
      valueGetter: (params: any) =>
        departmentsData.find(
          (dep: any) => dep._id === params.data?.department_id
        )?.name || "",
    },
    { headerName: "تگ ها", field: "tags" },
    { headerName: "انتشار", field: "is_active" },
  ];

  const handleEditSubmit = async (values: ArticleDataProps) => {
    try {
      setLoading(true);
      const { article_id, ...cleanData } = values;
      const response = await editArticle(article_id, cleanData)(dispatch);
      if (response.data) {
        const editData = { ...cleanData, _id: article_id };
        setArticlesData((prev: any) =>
          prev.map((art: any) =>
            art._id === formData.article_id ? { ...art, ...editData } : art
          )
        );
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("ویرایش مقاله با موفقیت صورت پذیرفت"));
        dispatch(setRowStatus("clear id", false));
        setFormData({
          ...initialData,
          created_by: currentUserData._id,
        });
        setEditFlag(false);
        setLoading(false);
        const notificationData = createNotificationData({
          data: cleanData,
          departmentsData,
          currentUserData,
          groupingData,
          type: "edit",
          subject: "مقاله",
        });
        await addNotification(notificationData)(dispatch);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSetEditData = async (clear: boolean, id: any) => {
    setEditFlag(clear ? false : true);
    try {
      const editData = articlesData?.find((art: any) => art._id === id);
      const response = await getArticleById(id)(dispatch);
      if (editData && response.data && !clear) {
        const { _id, ...data } = editData as ArticleDataProps;
        setFormData({
          ...data,
          article_id: _id,
          content: response.data.content,
          index_picture: response.data.index_picture,
        });
      }
      if (clear) {
        setFormData({
          ...formData,
          content: "",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      await removeArticle(id)(dispatch);
      setArticlesData((prev: any) =>
        prev?.filter((art: any) => art._id !== id)
      );

      dispatch(setAlert(true));
      dispatch(setAlertSeverity("success"));
      dispatch(setAlertContext(" حذف مقاله با موفقیت صورت پذیرفت"));
      const notificationData = createNotificationData({
        data: articlesData.find((item: any) => item._id === id),
        departmentsData,
        currentUserData,
        groupingData,
        type: "delete",
        subject: "مقاله",
      });
      await addNotification(notificationData)(dispatch);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col items-center w-full">
      <Container header="لیست مقالات">
        <Grid
          height={700}
          columns={columns}
          userData={articlesData}
          pageSize={20}
          editable={false}
          deleteBtn={true}
          editBtn={true}
          publishBtn={false}
          pagination={true}
          btnHeader="عملیات"
          handleDelete={handleDelete}
          handleSetData={handleSetEditData}
        />
      </Container>
      <div
        className="flex flex-col items-center w-full"
        style={{ display: editFlag ? "block" : "none" }}
      >
        <Container header="ویرایش">
          <ArticleComponent
            handleSubmit={handleEditSubmit}
            formData={formData}
            setFormData={setFormData}
            currentUserId={currentUserData._id}
            loading={loading}
          />
        </Container>
      </div>
    </div>
  );
}
